import { render } from "./ConferenceAvant.vue?vue&type=template&id=7cb13a52&scoped=true&ts=true"
import script from "./ConferenceAvant.vue?vue&type=script&lang=ts"
export * from "./ConferenceAvant.vue?vue&type=script&lang=ts"

import "./ConferenceAvant.vue?vue&type=style&index=0&id=7cb13a52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb13a52"]])

export default __exports__